import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const shareUrl = (path: string) => `${process.env.REACT_APP_BACKEND_URL}/api/share${path}`;

export function ShareButton({ path, title, className = "", label = false }: { path: string; title: string; className?: string; label?: boolean }) {
  const share = async () => {
    const url = shareUrl(path);
    const m = path.match(/^\/(blog|products)\/([^/]+)/);
    if (m) api.post(`/${m[1]}/${m[2]}/share`, { network: "link" }).catch(() => {});
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch { /* closed */ }
      return;
    }
    try { await navigator.clipboard.writeText(url); toast("Link copied — paste it anywhere to share"); }
    catch { window.prompt("Copy this link", url); }
  };
  return (
    <button type="button" onClick={share} aria-label="Share" className={`inline-flex items-center gap-2 ${className}`} data-testid="share-button">
      <Share2 size={label ? 15 : 18} strokeWidth={1.3} />{label && <span>Share</span>}
    </button>
  );
}
